define('navigation',['require','exports','module'],function(require, exports, module) {
  module.exports = {
    items: [],
  };
});

